import { HStack, Icon, Text } from '@chakra-ui/react';
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaTimesCircle,
  FaMinusCircle,
} from 'react-icons/fa';

import {
  type MatchStatus,
  getMatchStatusColor,
} from '../../utils/coverageMatchStatus';

interface CoverageMatchIndicatorProps {
  status: MatchStatus;
  value: string | null;
}

const StatusIcon = ({ status }: { status: MatchStatus }) => {
  const color = getMatchStatusColor(status);

  switch (status) {
    case 'match':
      return <Icon as={FaCheckCircle} boxSize="14px" color={color} />;
    case 'alternative':
      return <Icon as={FaExclamationCircle} boxSize="14px" color={color} />;
    case 'unavailable':
      return <Icon as={FaTimesCircle} boxSize="14px" color={color} />;
    case 'not-requested':
      return <Icon as={FaMinusCircle} boxSize="14px" color={color} />;
  }
};

const isSimpleValue = (value: string | null): boolean => {
  if (!value) return true;
  const normalized = value.toLowerCase().trim();
  return normalized === 'yes' || normalized === 'no' || normalized === '-';
};

export const CoverageMatchIndicator = ({
  status,
  value,
}: CoverageMatchIndicatorProps) => {
  if (status === 'unavailable' || status === 'not-requested') {
    return <StatusIcon status={status} />;
  }

  const showTextWithIcon = !isSimpleValue(value) || status === 'alternative';

  if (!showTextWithIcon) {
    return <StatusIcon status={status} />;
  }

  return (
    <HStack spacing={1} justify="center">
      <StatusIcon status={status} />
      {value && (
        <Text fontSize="sm" fontWeight="500">
          {value}
        </Text>
      )}
    </HStack>
  );
};
